/*
  Public blog reads.

  RLS restricts anon to status = 'published', so a draft is invisible
  here even though the query doesn't name it — the filter below is for
  ordering and clarity, not for security.
*/
import { supabase } from '../backend/lib/supabaseClient';

/* The blog table hasn't been created yet if backend/sql/blog.sql
   was never run. Detect it so the page can say so plainly. */
export const isMissingBlogTable = (error) =>
  !!error &&
  (error.code === '42P01' ||
    error.code === 'PGRST205' ||
    /relation .* does not exist/i.test(error.message || '') ||
    /could not find the table/i.test(error.message || ''));

export const getPublishedPosts = async () => {
  const { data, error } = await supabase
    .from('blog_posts')
    .select('id, slug, title, excerpt, cover_image, published_at, created_at')
    .eq('status', 'published')
    .order('published_at', { ascending: false, nullsFirst: false })
    .order('created_at', { ascending: false });

  return { data: data || [], error };
};

export const getPostBySlug = async (slug) => {
  const { data, error } = await supabase
    .from('blog_posts')
    .select('*')
    .eq('slug', slug)
    .eq('status', 'published')
    .maybeSingle();

  return { data, error };
};

/* Products an article is about, in the order the author listed them. */
export const getPostProducts = async (productIds) => {
  if (!productIds?.length) return { data: [], error: null };

  const { data, error } = await supabase
    .from('products')
    .select('*')
    .in('id', productIds)
    .eq('is_active', true);

  if (error || !data) return { data: [], error };

  const order = new Map(productIds.map((id, i) => [id, i]));
  const sorted = [...data].sort(
    (a, b) => (order.get(a.id) ?? 0) - (order.get(b.id) ?? 0)
  );

  return { data: sorted, error: null };
};
